module.exports = __webpack_public_path__ + "static/altana-zima-70b23f35dfdd9a89e619f388ac1466bf.jpg";